import { useMutation, useQueryClient } from '@tanstack/react-query'
import User from '../../model/User'
import { authService, dataSource } from '../../service/domain/_service.config'
import { USER_QUERY_KEY } from '../user/useUser'

export function useSignUp() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      firstName,
      lastName,
      email,
      password,
    }: {
      firstName: string
      lastName: string
      email: string
      password: string
    }) => {
      const userID = await authService.signUp(email, password)
      const user = User.create(userID, firstName, lastName)
      await dataSource.saveUser(user)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: USER_QUERY_KEY })
    },
  })
}
